import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// tslint:disable:nx-enforce-module-boundaries
import { ClientSharedUiThemeModule } from '@elight/client/shared/ui/theme';
import { ClientSharedUtilityCommonModule } from '@elight/client/shared/utility/common';
// tslint:enable:nx-enforce-module-boundaries
import { ClientSharedUiCommonModule } from '@elight/client/shared/ui/common';
import { ClientSharedDataAccessUserModule } from '@elight/client/shared/data-access/users';

import { LoginPageComponent } from './login-page/login-page.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { LoginRoutingModule } from './login-routing.module';
import { ResetPasswordDialogComponent } from './login-page/reset-password-dialog.component';
import { ClientSharedUtilityStorageModule } from '@elight/client/shared/utility/storage';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        LoginRoutingModule,
        ClientSharedUiThemeModule,
        ClientSharedUiCommonModule,
        ClientSharedDataAccessUserModule,
        ClientSharedUtilityCommonModule,
        ClientSharedUtilityStorageModule,
    ],
    declarations: [
        LoginPageComponent,
        RegisterPageComponent,
        ResetPasswordDialogComponent,
    ],
})
export class ClientFeatureLoginModule {}
